export default __webpack_public_path__ + "img/img_placeholder-8a7f537f0fcb270cf3e077f633034fda.png";